module.exports = __webpack_public_path__ + "static/img/bags.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/bags.jpg
// module id = h75U
// module chunks = 1